<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/4TwQsC/tc-custom/9780547563886.jpg?1734284468466" alt="This image is the cover for the book Hill of Evil Counsel"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Hill of Evil Counsel
      </h1>
      <p class="bookDescription body article font2">
        <b>Three stories of “sensuous prose and indelible imagery” that re-create the world of Jerusalem during the last days of the British Mandate (<i>The New York Times</i>).</b><br/>  <br/> Refugees drawn to Jerusalem in search of safety are confronted by activists relentlessly preparing for an uprising, oblivious to the risks. Meanwhile, a wife abandons her husband, and a dying man longs for his departed lover. Among these characters lives a boy named Uri, a friend and confidant of several conspirators who love and humor him as he weaves in and out of all three stories. <i>The Hill of Evil Counsel</i> is “as complex, vivid, and uncompromising as Jerusalem itself” (<i>The Nation</i>).<br/><br/> “Oz evokes Israeli life with the same sly precision with which Chekhov evoked pre-Revolutionary Russian life.” —<i>Los Angeles Times</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Amos Oz
      </h2>
      
      <p class="authorDescription body article">Amos Oz was born in Jerusalem in 1939. He is the author of twenty novels and collections of short fiction, and ten works of nonfiction. His acclaimed memoir <I>A Tale of Love and Darkness</I> was an international bestseller and recipient of the prestigious Goethe Prize, as well as the National Jewish Book Award. <I>Scenes from Village Life</I>, a New York Times Notable Book, was awarded the Prix M&eacute;diterran&eacute;e &Eacute;tranger in 2010. Oz lives in Tel Aviv, Israel.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Houghton Mifflin Harcourt (www.hmhco.com)
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0d8f6945